var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernmentIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1H2C1.44772 1 1 1.44772 1 2V16C1 16.5523 1.44772 17 2 17H20C20.5523 17 21 16.5523 21 16V2C21 1.44772 20.5523 1 20 1Z",
    stroke: "#060606",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.5C8.03043 9.5 8.53914 9.28929 8.91421 8.91421C9.28929 8.53914 9.5 8.03043 9.5 7.5C9.5 6.96957 9.28929 6.46086 8.91421 6.08579C8.53914 5.71071 8.03043 5.5 7.5 5.5C6.96957 5.5 6.46086 5.71071 6.08579 6.08579C5.71071 6.46086 5.5 6.96957 5.5 7.5C5.5 8.03043 5.71071 8.53914 6.08579 8.91421C6.46086 9.28929 6.96957 9.5 7.5 9.5V9.5Z",
    stroke: "#060606",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11H17M10.5 12.5C10.5 11.7044 10.1839 10.9413 9.62132 10.3787C9.05871 9.81607 8.29565 9.5 7.5 9.5C6.70435 9.5 5.94129 9.81607 5.37868 10.3787C4.81607 10.9413 4.5 11.7044 4.5 12.5H10.5ZM13 7H17H13Z",
    stroke: "#060606",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentIdIcon);
export default __webpack_public_path__ + "static/media/government-id--icon.68680582470195af0557215943e02cfe.svg";
export { ForwardRef as ReactComponent };